module.exports = __webpack_public_path__ + "static/img/thoracicPain_2.2867085c.png";